module.exports = __webpack_public_path__ + "static/media/iconNumber.3e17e0e8.svg";